import {EatAttribution, emptyEatAttribution, hasEatAuthor, normalizeEatAttribution} from '@/service/extractEatAttribution';
import {ScrapperResponse} from '@/model/Scrapper';
import {Environment} from '@/utils/Environment';

export async function loadEatAttributionForUrl(
    url: string,
    scraped?: ScrapperResponse | null
): Promise<EatAttribution> {
    if (scraped?.eatAttribution && hasEatAuthor(scraped.eatAttribution)) {
        return normalizeEatAttribution(scraped.eatAttribution);
    }
    if (!url || !Environment.isLocalPreviewHost()) {
        return emptyEatAttribution();
    }
    try {
        const response = await fetch('/__extract-eat?url=' + encodeURIComponent(url));
        if (!response.ok) {
            return emptyEatAttribution();
        }
        const data = await response.json();
        return normalizeEatAttribution(data.eatAttribution);
    } catch {
        return emptyEatAttribution();
    }
}
